import SecaoService from "@/services/SecaoProdutoService"

export const actions = {
    cadastrarSecaoProduto: ({commit, dispatch}) => {
        commit('setSecaoProduto', {
            secao: ''
        })
        dispatch('setModalCadastroSecaoProduto', true)
    },
    listarSecoesProduto: ({commit}) => {
        commit('setOverlay', true)
        SecaoService.listar()
        .then(res => {
            commit('setSecoesProduto', res.data)
            commit('setOverlay', false)
        })
        .catch(e => {
            console.log(e)
            commit('setOverlay', false)
        })
    },
    visualizarSecaoProduto: ({commit}, id) => {
        commit('setOverlay', true)
        SecaoService.editar(id)
        .then(res => {
            commit('setSecaoProduto', res.data)
            commit('setOverlay', false)
            commit('setModalCadastroSecaoProduto', true)
        })
        .catch(e => {
            console.log(e)
            commit('setOverlay', false)
        })
    },
    salvarSecaoProduto: ({commit, dispatch}, data) => {
        commit('setModalCadastroSecaoProduto', false)
        commit('setOverlay', true)
        SecaoService.salvar(data)
        .then(res => {
            dispatch('listarSecoesProduto')
            commit('setOverlay', false)
            commit('snackbarSuccess', 'Seção cadastrada.')
        })
        .catch(e => {
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao cadastrar seção.')

        })
    },
    atualizarSecaoProduto: ({commit, dispatch}, data) => {
        commit('setModalCadastroSecaoProduto', false)
        commit('setOverlay', true)
        SecaoService.atualizar(data)
        .then(res => {
            dispatch('listarSecoesProduto')
            commit('setOverlay', false)
            commit('snackbarSuccess', 'Seção atualizada.')
        })
        .catch(e => {
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao atualizar seção.')

        })
    },
    excluirSecaoProduto: ({commit, dispatch}, id) => {
        commit('setModalCadastroSecaoProduto', false)
        commit('setModalExcluirSecaoProduto', false)
        commit('setOverlay', true)
        SecaoService.excluir(id)
        .then(res => {
            dispatch('listarSecoesProduto')
            commit('setOverlay', false)
            commit('snackbarError', 'Seção excluída.')
        })
        .catch(e => {
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao excluir seção.')

        })
    },
    setModalCadastroSecaoProduto: ({commit}, status) => {
        commit('setModalCadastroSecaoProduto', false)
        setTimeout(() => {
            commit('setModalCadastroSecaoProduto', status)
            
        }, 100);
    },
    setModalExcluirSecaoProduto: ({commit}, status) => {
        commit('setModalExcluirSecaoProduto', false)
        setTimeout(() => {
            commit('setModalExcluirSecaoProduto', status)
            
        }, 100);
    }

}

export default {}